function MatchHeight() {
  jQuery(".image-link-blocks__title").matchHeight(); 
  jQuery(".image-link-blocks__item").matchHeight(); 
  jQuery(".multi-column__item   .v-stack .h3").matchHeight(); 
  jQuery(".multi-column__item   .v-stack .h4").matchHeight(); 
  jQuery(".multi-column__item   .v-stack .h2").matchHeight(); 
  jQuery(".multi-column__item   .v-stack .h5").matchHeight(); 
  jQuery(".multi-column__item  .prose>p").matchHeight(); 
  
  jQuery(".blog-post-card__info .v-stack  .h3>a ").matchHeight(); 
  jQuery(".blog-post-card__info .v-stack > p ").matchHeight();   
  jQuery(".product-card__title").matchHeight(); 
  jQuery(".product-card__info .rating-with-text.w-full .text-xs").matchHeight();
  jQuery(".product-card__price").matchHeight();
  jQuery(".image-link-blocks__inner .img-block-equal").matchHeight();


}

$(document).ready(function(){
  $("input[name='contact[Phone]']").keypress(function (e) {      
      var charCode = (e.which) ? e.which : event.keyCode    
      if (String.fromCharCode(charCode).match(/[^0-9+]/g))    
          return false;                        
      });
  MatchHeight();
  $('.sub-link.active').parent('ul').parent('div').parent('details').parent('li').addClass('active');
  $('.sub-sub-link.active').parent('ul').parent('li').parent('ul').parent('div').parent('details').parent('li').addClass('active');

  jQuery(document).on("click", '#products .collection__facets, .facets-summary, .collection__results .active-facets, #facets-drawer', function(event) { 
      console.log('filter1');
      setTimeout(function() {
        MatchHeight();
      }, 1000);        
  });
  jQuery(document).on("click", '.collection__pagination .pagination__item.group', function(event) { 
      console.log('page 1');
      setTimeout(function() {
        MatchHeight();
      }, 1000);        
  });
  
  jQuery("span.cst-read-more").click(function(){
    jQuery(".product-info__description").removeClass("show-less");
    jQuery("span.cst-read-more").removeClass("active");
    jQuery("span.cst-read-more").hide();

    jQuery("span.cst-read-less").show();
    jQuery(".product-info__description").addClass("show-more");
    jQuery("span.cst-read-less").addClass("active");
  });
  jQuery("span.cst-read-less").click(function(){
    jQuery(".product-info__description").removeClass("show-more");
    jQuery("span.cst-read-less").removeClass("active");
    jQuery("span.cst-read-less").hide();

    jQuery("span.cst-read-more").show();
    jQuery(".product-info__description").addClass("show-less");
    jQuery("span.cst-read-more").addClass("active");
  });
  
});

$( window ).on("load", function() {  
  MatchHeight();  
});